import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  catchError,
  filter,
  Observable,
  switchMap,
  take,
  throwError,
} from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { BYPASS_AUTH_RECOVERY } from './http.service';
import { RefreshTokenStateService } from './refresh-token-state.service';
import { ReturnUrlService } from './return-url.service';

export function jwtInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthenticationService);
  const refreshTokenStateService = inject(RefreshTokenStateService);
  const router = inject(Router);
  const returnUrlService = inject(ReturnUrlService);

  const logoutAndRedirect = (err: unknown) => {
    returnUrlService.save(router.url);
    authService.logout();
    router.navigate(['/auth/sign-in']);
    return throwError(() => err);
  };

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.context.get(BYPASS_AUTH_RECOVERY)) {
        return throwError(() => error);
      }

      if (error.status !== 401 || req.url.includes('/auth/')) {
        return throwError(() => error);
      }

      if (refreshTokenStateService.refreshTokenInProgress) {
        return refreshTokenStateService.refreshTokenInProgress$.pipe(
          filter(inProgress => inProgress === false),
          take(1),
          switchMap(() => next(req))
        );
      }

      refreshTokenStateService.setRefreshTokenInProgress(true);

      return authService.refreshToken().pipe(
        catchError(err => {
          refreshTokenStateService.setRefreshTokenInProgress(false);
          return logoutAndRedirect(err);
        }),
        switchMap(() => {
          refreshTokenStateService.setRefreshTokenInProgress(false);
          return next(req);
        })
      );
    })
  );
}
